import React, { useState, useEffect } from 'react';
import { withRouter, NavLink, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';

import { newFetch, GET, POST, DELETE } from '../../../helpers/fetch';
import SpringLoader from '../../../components/SpringLoader/SpringLoader.js';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../components/SweetAlert';
import { config } from '../../../config';
import { truncateText } from '../../../helpers/general';

const { SERVER_URL } = config;

const Catalogue = ({ history }) => {
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const [catalogues, setCatalogues] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [statusOptions, setStatusOptions] = useState([]);

  const [sortModel, setSortModel] = useState([
    { field: 'id', sort: 'asc' }, // Initial sort field and order
  ]);
  const [clients, setClients] = useState([]);

  const defaultFontColor = '#000000';

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      resizable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="row">
            <div className="col-md-4 text-center">
              <img
                src={`${SERVER_URL}/${params.row.images[0]?.new_image}`}
                style={{ height: '30px' }}
                alt=""
              />
            </div>
            <div className="col-md-8 ">
              <div className="">
                <div className="row">
                  <div className="col-md-12">
                    <span
                      style={{
                        fontWeight: '700',
                        fontSize: 13,
                        color: '#7c98b5',
                      }}
                    >
                      {params.row.id}
                    </span>
                  </div>
                </div>
                <div className="row">
                  <Link
                    className="text-primary "
                    to={`/catalogue/edit/${params.id}`}
                  >
                    <div className="col-md-12 adjust-fs text-muted">
                      {params.row.name}
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: 'client.name',
      headerName: 'Client',
      flex: 1,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <span
            className="adjust-fs text-muted"
            style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}
          >
            {params.row.client.name || '--'}
          </span>
        );
      },
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <span
            className="adjust-fs text-muted"
            style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}
          >
            {truncateText(params.row.description) || '--'}
          </span>
        );
      },
    },
    {
      field: 'stock',
      headerName: 'Stock',
      flex: 1,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <span
            className="adjust-fs text-muted"
            style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}
          >
            {params.row.stock || '--'}
          </span>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div
            className={`badge ${
              params.row.status == 11
                ? 'bg-primary-custom'
                : params.row.status == 12
                ? 'bg-danger-custom'
                : 'bg-dark'
            } adjust-fs adjust-shadow fw-normal`}
            style={{
              fontSize: 14,
              color: '#fff',
              fontWeight: 200,
              padding: '6px 17px',
            }}
          >
            {statusOptions.find((file, i) => file.id == params.row.status)
              .label || '--'}
          </div>
        );
      },
    },
    {
      field: 'createdAt',
      headerName: 'Date Created',
      flex: 1,
      resizable: false,
      filterable: false,
      renderCell: (params) => {
        const date = new Date(params.row.createdAt);

        if (!params.row.createdAt) return '--';

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;

        return (
          <span className="adjust-fs text-muted fw-normal">
            {formattedDate}
          </span>
        );
      },
    },
  ];

  const [data, setData] = React.useState([]);

  const fetchCatalogue = async (pagination, field, sort) => {
    setLoading(true);
    let api_path = `/catalogue/list/filter`;
    let response = await newFetch(POST, api_path, {
      field,
      sort,
      page: pagination.page,
      pageSize: pagination.pageSize,
      clientID,
    });

    if (response.success) {
      const catalogueData = response.data.list;

      setCatalogues(catalogueData);
      setTotalRows(response.data.total_record);
    }
    setLoading(false);
  };

  const fetchStatusOptions = async () => {
    let api_path = `/fields/catalogue_status`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setStatusOptions(response.data);
    }
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
  };

  const handleDelete = async (id) => {
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to delete this Catalogue?'
    );
    if (isConfirmed) {
      let api_path = `/catalogue/${id}`;
      let response = await newFetch(DELETE, api_path);

      if (response.success) {
        ToastUtil.success(response.message);
        window.location.reload();
      }
    }
  };

  const fetchClients = async () => {
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
    }
  };

  React.useLayoutEffect(() => {
    setData(catalogues !== undefined ? catalogues : []);

    catalogues !== undefined && setLoading(false);
  }, [catalogues]);

  useEffect(() => {
    fetchStatusOptions();
  }, []);

  useEffect(() => {
    const { field, sort } = sortModel[0] || {};
    fetchCatalogue(paginationModel, field, sort);
    fetchClients();
  }, [sortModel, paginationModel, clientID]);

  return (
    <>
      <div
        className="container-fluid"
        style={{
          paddingLeft: '2rem',
          paddingRight: '2rem',
          paddingBottom: '6rem',
        }}
      >
        <div className="border-bottom pb-2 py-2 d-flex align-items-center">
          <h6 className="flex-grow-1 pt-4" style={{ color: '#5156BE' }}>
            Catalogue
          </h6>
          {clients.enable_catalogue && (
            <NavLink
              to="/catalogue/add"
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <button
                className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
                style={{ width: '200px' }}
              >
                Add New
              </button>
            </NavLink>
          )}
        </div>
        {clients.enable_catalogue ? (
          <>
            <div className="d-flex flex-row align-items-center justify-content-between py-3">
              <h6 className="flex-grow-1">Catalogue ({totalRows})</h6>
            </div>
            <div className="table-responsive rounded shadow bg-white">
              {loading ? (
                <div className="springloader-holder" style={{position: 'relative'}}>
                  <SpringLoader />
                </div>
              ) : (
                <Box sx={{ width: '100%', fontSize: 16 }}>
                  <DataGrid
                    columns={columns}
                    rows={data}
                    rowCount={totalRows}
                    loading={loading}
                    pageSizeOptions={[10, 20, 30, 40, 50, 80, 100]}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                    localeText={{
                      noRowsLabel: 'No catalogues found.',
                    }}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                      },
                    }}
                    style={{ minHeight: 100 }}
                    sortModel={sortModel}
                    onSortModelChange={handleSortModelChange}
                    getRowHeight={() => 'auto'}
                    sx={{
                      [`& .${gridClasses.cell}`]: {
                        py: 3,
                      },
                      [`& .${gridClasses.columnHeader}`]: {
                        fontSize: '14px',
                        fontWeight: 400,
                        color: '#6c757d!important',
                      },
                      [`& .${gridClasses.row}`]: {
                        fontSize: '14px',
                        color: '#5156BE!important',
                        fontWeight: 700,
                      },
                    }}
                    disableSelectionOnClick
                    isRowSelectable={() => false}
                  />
                </Box>
              )}
            </div>
          </>
        ) : (
          <div className="text-muted pt-4">
            The client does not have access to this module.
          </div>
        )}
      </div>
    </>
  );
};

export default withRouter(Catalogue);
